import type { ISkeletonLoaderProps, TSkeletons } from '@frontend/pole-ui/lib/components/Skeleton'
import type { TResponsiveValue } from '@/utils/hooks/responsive/interfaces'

const tagItemSkeleton: ISkeletonLoaderProps = {
  className: 'journalTagItemCard journalTagItemCard__link',
  height: null,
  styleName: 'white',
  skeletons: [
    {
      className: 'journalTagItemCard__title',
      styleName: 'white',
      height: null,
      skeletons: [{ className: 'h3' }, { className: 'text_lead journalTagItemCard__subtitle' }],
    },
  ],
}

export const JOURNAL_TAG_ITEM_SKELETON: TSkeletons = [
  {
    ...tagItemSkeleton,
    skeletons: [...(tagItemSkeleton.skeletons as TSkeletons), { className: 'journalTagItemCard__previewImage', width: null, height: null }],
  },
  tagItemSkeleton,
  tagItemSkeleton,
  tagItemSkeleton,
  tagItemSkeleton,
  tagItemSkeleton,
  tagItemSkeleton,
  tagItemSkeleton,
  tagItemSkeleton,
]

export const RESPONSIVE_TAG_CARDS_PER_PAGE: TResponsiveValue<number> = {
  desktop: 8,
  tablet: 8,
  mobile: 10,
}
